// extracted by mini-css-extract-plugin
export default {"adornment":"xXus_xABQq9ylLrTNKcg","label":"JZxg7wvQxUTjC6hEWitz","value":"pEtLCmibbZPx0blu4tnv"};